export default function BarnIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
      <g data-name="06-barn">
        <path fill="#e9aa70" d="M32 35v24l-7.5-12zM47 35v24l-7.5-12z" />
        <g fill="#d99c64">
          <path d="m17 35 7.5 12L17 59zM32 35l7.5 12L32 59zM39.5 47 47 59H32zM24.5 47 32 59H17z" />
          <path d="m32 35-7.5 12L17 35zM47 35l-7.5 12L32 35z" />
        </g>
        <path
          fill="#544f43"
          d="M38.43 20.67a.85.85 0 0 1-.35.16.87.87 0 0 1-.31-.1 2.7 2.7 0 0 0-1.59.04 2.12 2.12 0 0 0-.69.25 3.86 3.86 0 0 0-.67.67 5.69 5.69 0 0 1-1.83 1.16 1.16 1.16 0 0 1-.47.14c-.41-.01-.68-.45-1.02-.7-.4-.3-.92-.35-1.3-.67-.34-.29-.53-.76-.87-1.04a1.36 1.36 0 0 0-1.4-.13 2.83 2.83 0 0 0-1.13 1.02 1.73 1.73 0 0 0-1.33-.65A4.07 4.07 0 0 0 24 21v-1a8 8 0 1 1 16-.01 4.47 4.47 0 0 0-1.57.68z"
        />
        <path
          fill="#ffdf64"
          d="M37.77 20.73a.87.87 0 0 0 .31.1.85.85 0 0 0 .35-.16 4.47 4.47 0 0 1 1.57-.68V26H24v-5a4.07 4.07 0 0 1 1.47-.18 1.73 1.73 0 0 1 1.33.65 2.83 2.83 0 0 1 1.13-1.02 1.36 1.36 0 0 1 1.4.13c.34.28.53.75.87 1.04.38.32.9.37 1.3.67.34.25.61.69 1.02.7a1.16 1.16 0 0 0 .47-.14 5.69 5.69 0 0 0 1.83-1.16 3.86 3.86 0 0 1 .67-.67 2.12 2.12 0 0 1 .69-.25 2.7 2.7 0 0 1 1.59-.04z"
        />
        <path
          fill="#af7a58"
          d="M50 33.5a1.5 1.5 0 0 1-1.5 1.5h-33a1.5 1.5 0 0 1 0-3h33a1.5 1.5 0 0 1 1.5 1.5zM63 59v4H1v-4h58z"
        />
        <path
          fill="#635d50"
          d="m52 7 11 19-4 2-10-17-17-5-17 5L5 28l-4-2L12 7l20-6z"
        />
        <path
          fill="#ff6c52"
          d="M48.5 35a1.5 1.5 0 0 0 0-3h-33a1.5 1.5 0 0 0 0 3H17v24H5V28l10-17 17-5 17 5 10 17v31H47V35zM40 26v-6.01A8 8 0 0 0 24 20v6z"
        />
        <path
          fill="#423e35"
          d="M32 15a7.96 7.96 0 0 1 7.47 5.16 4.43 4.43 0 0 1 .53-.17A8 8 0 0 0 24 20v1a2.68 2.68 0 0 1 .28-.06A8 8 0 0 1 32 15z"
        />
        <path
          fill="#fffcbd"
          d="M38.43 20.67a.85.85 0 0 1-.35.16.87.87 0 0 1-.31-.1 2.7 2.7 0 0 0-1.59.04 2.12 2.12 0 0 0-.69.25 3.86 3.86 0 0 0-.67.67 5.69 5.69 0 0 1-1.83 1.16 1.16 1.16 0 0 1-.47.14c-.41-.01-.68-.45-1.02-.7-.4-.3-.92-.35-1.3-.67-.34-.29-.53-.76-.87-1.04a1.36 1.36 0 0 0-1.4-.13 2.83 2.83 0 0 0-1.13 1.02 1.73 1.73 0 0 0-1.33-.65A4.07 4.07 0 0 0 24 21v2a4.07 4.07 0 0 1 1.47-.18 1.73 1.73 0 0 1 1.33.65 2.83 2.83 0 0 1 1.13-1.02 1.36 1.36 0 0 1 1.4.13c.34.28.53.75.87 1.04.38.32.9.37 1.3.67.34.25.61.69 1.02.7a1.16 1.16 0 0 0 .47-.14 5.69 5.69 0 0 0 1.83-1.16 3.86 3.86 0 0 1 .67-.67 2.12 2.12 0 0 1 .69-.25 2.7 2.7 0 0 1 1.59-.04.87.87 0 0 0 .31.1.85.85 0 0 0 .35-.16 4.47 4.47 0 0 1 1.57-.68v-2a4.47 4.47 0 0 0-1.57.68z"
        />
        <path
          fill="#845335"
          d="M48.5 34h-33a1.5 1.5 0 0 1-1.4-1 1.49 1.49 0 0 0 1.4 2h33a1.49 1.49 0 0 0 1.4-2 1.5 1.5 0 0 1-1.4 1z"
        />
        <path
          fill="#423e35"
          d="m61.88 24.06-.25.13a2 2 0 0 1-2.6-.73L50 9 32 4 14 9 4.96 23.46a2 2 0 0 1-2.59.73l-.25-.13L1 26l4 2 10-17 17-5 17 5 10 17 4-2z"
        />
        <path fill="#845335" d="M1 61h62v2H1z" />
        <path
          fill="#db0404"
          d="m32 6-17 5L5 28h3l9-15 15-4 15 4 9 15h3L49 11z"
        />
        <path fill="#ff9b87" d="M56 28h3v31h-3zM5 28h3v31H5z" />
        <ellipse
          cx="49.68"
          cy="23.7"
          fill="#f6fafd"
          rx="1.64"
          ry="2.29"
          transform="rotate(-45.01 49.7 23.7)"
        />
        <ellipse
          cx="51.68"
          cy="27.71"
          fill="#f6fafd"
          rx=".82"
          ry="1.15"
          transform="rotate(-45.01 51.7 27.72)"
        />
        <path fill="#b56e2f" d="M17 35h30v4H17z" />
        <path d="M63 58h-3v-2h-2v2H48V36h.5a2.5 2.5 0 0 0 0-5h-33a2.5 2.5 0 0 0 0 5h.5v22H6V39H4v19H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h62a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zM40.68 47 46 38.49V55.5zm-1.18-1.89L33.8 36h11.4zM33 38.5 38.32 47 33 55.51zM31 55.5 25.68 47 31 38.49zm-6.5-10.4L18.8 36h11.4zM23.32 47 18 55.51V38.5zm1.18 1.89L30.2 58H18.8zm15 0L45.2 58H33.8zM15 33.5a.5.5 0 0 1 .5-.5h33a.5.5 0 0 1 0 1h-33a.5.5 0 0 1-.5-.5zM62 62H2v-2h60z" />
        <path d="M.55 26.9 4 28.62V33h2v-4.73l9.66-16.42L32 7.05l16.34 4.8L58 28.27V54h2V28.62l3.45-1.72a1 1 0 0 0 .41-1.4l-1.73-3-1.73 1 1.2 2.08-2.22 1.1-9.52-16.19a1 1 0 0 0-.58-.45l-17-5a1 1 0 0 0-.56 0l-17 5a1 1 0 0 0-.58.45L4.6 26.7 2.4 25.6 11.7 9.5l-1.72-1-9.84 17a1 1 0 0 0 .41 1.4z" />
        <path d="m32 2.04 19.33 5.8 5.6 9.66 1.73-1-5.8-10a1 1 0 0 0-.57-.45l-20-6a1 1 0 0 0-.58 0l-20 6 .58 1.91zM58.1 19.59l1.74-1 1.1 1.9-1.73 1zM4 35h2v2H4z" />
        <path d="M23 20v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6a9 9 0 0 0-18 0zm2 5v-3.17h.43a.73.73 0 0 1 .57.24 1 1 0 0 0 .8.4 1 1 0 0 0 .8-.42 2.04 2.04 0 0 1 .73-.69.39.39 0 0 1 .36 0 2 2 0 0 1 .26.31 3.52 3.52 0 0 0 .6.7 3.2 3.2 0 0 0 .96.53 1.93 1.93 0 0 1 .39.18 2.18 2.18 0 0 1 .2.19 2.03 2.03 0 0 0 1.4.71h.02a2.04 2.04 0 0 0 .88-.23 6.63 6.63 0 0 0 2.14-1.38l.2-.24a1.94 1.94 0 0 1 .28-.28 1.59 1.59 0 0 1 .37-.1 2.03 2.03 0 0 1 1.04-.08 1.41 1.41 0 0 0 .66.15 1.6 1.6 0 0 0 .88-.33H39V25zm13.96-5.73a5.87 5.87 0 0 0-.96.48 3.75 3.75 0 0 0-2.04.05 3.02 3.02 0 0 0-1.01.38 3.26 3.26 0 0 0-.7.65l-.16.17a4.83 4.83 0 0 1-1.5.93 2.88 2.88 0 0 1-.1-.1 4.25 4.25 0 0 0-.4-.35 3.52 3.52 0 0 0-.85-.44 1.65 1.65 0 0 1-.4-.19 2 2 0 0 1-.26-.32 3.4 3.4 0 0 0-.63-.73 2.33 2.33 0 0 0-2.44-.26 3.18 3.18 0 0 0-.85.56 2.91 2.91 0 0 0-1.17-.28H25a7 7 0 0 1 13.96-.55z" />
      </g>
    </svg>
  );
}
